var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H2V14h28v12zM2 10.084V6h28v4.084H2zM5 24h10a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2zm13-1a1 1 1080 1 0 2 0 1 1 1080 1 0-2 0zm4 0a1 1 1080 1 0 2 0 1 1 1080 1 0-2 0zm4 0a1 1 1080 1 0 2 0 1 1 1080 1 0-2 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.eec8b77f2482cec5bdca6242b5b8b3d9.svg";
export { ForwardRef as ReactComponent };